(function () {
  "use strict";

  var CONFIG = window.TEMP_RETAIL_CONFIG || {};
  var MODE_ANIMATION_PATH =
    CONFIG.animationPath || "./fullyImmersiveAnimation.json";
  var DATA_PATH = CONFIG.dataPath || "./temp_retail-data.json";
  var SPLASH_VIDEO_PATH = CONFIG.splashVideo || "./temp-retail-splash.mp4";

  var SPLASH_STATIC_MS = 1000;
  var SPLASH_CLIP_END = 2.0;
  var SPLASH_TEXT_FADE_AT = 1.6;
  var CONNECT_LOOP_START = 2.0;
  var CONNECT_LOOP_END = 4.0;
  var SPLASH_RESUME_START = 4.0;
  var SPLASH_GRADIENT_DURATION = 3.0;
  var SPLASH_TEXT_FADE_DURATION = 0.8;
  var SPLASH_CONNECT_TRANSITION_DELAY = 450;
  var SPLASH_FALLBACK_END_MS = 6000;
  var SPLASH_PLAYBACK_RATE = Number(CONFIG.splashPlaybackRate) || 1;
  var CONNECT_TRANSITION_PLAYBACK_RATE =
    Number(CONFIG.connectSplashPlaybackRate) || 0.72;
  var CONNECT_HANDOFF_WINDOW_SEC =
    Number(CONFIG.connectHandoffWindowSec) || 0.32;
  var TRACK_STARTUP_BUFFER_MIN_SECONDS = 2.5;
  var TRACK_STARTUP_BUFFER_MAX_SECONDS = 7;
  var TRACK_STARTUP_BUFFER_RATIO = 0.04;
  var TRACK_STARTUP_READY_STATE_SECONDS = 1.5;
  var TRACK_REBUFFER_SECONDS = 4;
  var TRACK_REBUFFER_RATIO = 0.1;
  var CONNECT_HOTSPOT_X = 0.7;
  var CONNECT_HOTSPOT_Y = 0.38;

  var MODE_TAB_COPY = {
    hear: "the details",
    feel: "the beats",
    immerse: "in bass",
    beast: "in rumbles",
  };

  var DEFAULT_INLINE_DATA = {
    modes: [
      {
        id: "hear",
        title: "Hear",
        tab_sub: "the details",
        state_frame: 354,
        description:
          "Pure, detailed sound. Hear every layer clearly, perfect for vocals, podcasts and instruments.",
        playlist: [
          {
            id: "h1",
            title: "Sonic Clarity",
            artist: "Lamb Artist 1",
            duration: "1:24",
            audio_url: "",
          },
          {
            id: "h2",
            title: "Acoustic Layer",
            artist: "Lamb Artist 2",
            duration: "1:42",
            audio_url: "",
          },
          {
            id: "h3",
            title: "Vocal Focus",
            artist: "Lamb Artist 3",
            duration: "1:15",
            audio_url: "",
          },
        ],
      },
      {
        id: "feel",
        title: "Feel",
        tab_sub: "the beats",
        state_frame: 365,
        description:
          "Feel every beat hit. Balanced sound with bass you can actually feel.",
        playlist: [
          {
            id: "f1",
            title: "Bass Pulse",
            artist: "Lamb Artist 1",
            duration: "1:24",
            audio_url: "",
          },
          {
            id: "f2",
            title: "Rhythm Kick",
            artist: "Lamb Artist 4",
            duration: "1:30",
            audio_url: "",
          },
        ],
      },
      {
        id: "immerse",
        title: "Immerse",
        tab_sub: "in bass",
        state_frame: 390,
        description:
          "Get lost in the bass. Deep, surrounding sound for music that moves you.",
        playlist: [
          {
            id: "i1",
            title: "Deep Surround",
            artist: "Lamb Artist 5",
            duration: "2:05",
            audio_url: "",
          },
        ],
      },
      {
        id: "beast",
        title: "Beast",
        tab_sub: "in rumbles",
        state_frame: 415,
        description:
          "Turn it all the way up. Explosions. Rumbles. Pure power for gaming and cinema.",
        playlist: [
          {
            id: "b1",
            title: "Power Rumble",
            artist: "Lamb Artist 6",
            duration: "1:10",
            audio_url: "",
          },
        ],
      },
    ],
  };

  var state = {
    modes: [],
    activeModeId: null,
    currentTrackId: null,
    playableTracks: [],
    isPlaying: false,
    isBuffering: false,
    audioStatus: "idle",
    audioMessage: "",
    splashDismissed: false,
    splashFadeStarted: false,
    introDismissed: false,
    introTransitionStarted: false,
    sceneReady: false,
    currentTimeline: null,
    frameProxy: { frame: 354 },
    primedTrackId: null,
    pendingPlaybackAfterBuffer: false,
    rebufferAfterStall: false,
    startupBufferTargetSec: 0,
    suppressPauseMessage: false,
    silentBuffering: false,
    restoreMutedAfterBuffer: false,
    suppressSeekBuffering: false,
    showElapsedTime: false,
    playedPercent: 0,
    bufferedPercent: 0,
    preloadedImageUrls: {},
    heroIntroPlayed: false,
  };

  var els = {};
  var sceneAnimation = null;

  document.addEventListener("DOMContentLoaded", init);

  function init() {
    cacheElements();
    bindEvents();
    initSplash();

    window.dispatchEvent(new CustomEvent("retail:screen_view", {
      detail: { screen_name: "splash", previous_screen_name: "" }
    }));

    Promise.all([loadData(), initScene()])
      .then(function (results) {
        state.modes = normalizeModes((results[0] && results[0].modes) || []);

        if (!state.modes.length) {
          state.modes = normalizeModes(DEFAULT_INLINE_DATA.modes);
        }

        preloadAllArtwork(state.modes);
        renderTabs();
        switchMode(state.modes[0].id, true);
      })
      .catch(function () {
        state.modes = normalizeModes(DEFAULT_INLINE_DATA.modes);
        preloadAllArtwork(state.modes);
        renderTabs();
        switchMode(state.modes[0].id, true);
      });
  }

  function cacheElements() {
    els.root = document.querySelector(".tr-page");
    els.intro = document.getElementById("tr-intro");
    els.introFrame = els.intro
      ? els.intro.querySelector(".tr-intro__frame")
      : null;
    els.introMedia = document.getElementById("tr-intro-media");
    els.splashVideo = document.getElementById("tr-splash-video");
    els.splashText = document.getElementById("tr-intro-splash-text");
    els.connectText = document.getElementById("tr-intro-connect-text");
    els.introFooter = document.getElementById("tr-intro-footer");
    els.connectReady = document.getElementById("tr-connect-ready");
    els.splashFeel = document.getElementById("tr-splash-feel");
    els.connectHotspot = document.querySelector(".tr-connect-hotspot");

    els.tabs = document.getElementById("tr-mode-tabs");
    els.header = document.querySelector(".tr-header");
    els.heroSubtitle = document.querySelector(".tr-hero__subtitle");
    els.modeTitle = document.getElementById("tr-mode-title");
    els.modeDescription = document.getElementById("tr-mode-description");
    els.modeHeading = document.querySelector(".tr-hero__title");
    els.modeHeadingGradient = document.querySelector(".tr-hero__title span");
    els.visualSection = document.querySelector(".tr-visual-section");
    els.visualContainer = document.querySelector(".tr-visual-container");
    els.visualStage = document.getElementById("tr-visual-stage");
    els.visualScene = document.getElementById("tr-mode-scene");
    els.visualFallback = document.getElementById("tr-visual-fallback");
    els.disclaimerMode = document.getElementById("tr-disclaimer-mode");
    els.modeInfo = document.querySelector(".tr-mode-info");
    els.playlistSection = document.querySelector(".tr-playlist-section");
    els.playlistMode = document.getElementById("tr-playlist-mode");
    els.playlistList = document.getElementById("tr-playlist-list");
    els.exitTitle = document.getElementById("tr-exit-title");
    els.exitDescription = document.getElementById("tr-exit-description");

    els.audio = document.getElementById("tr-audio");
    els.audioPreload = document.getElementById("tr-audio-preload");

    els.activePlayer = document.getElementById("tr-active-player");
    els.apTitle = document.getElementById("tr-ap-title");
    els.apArtist = document.getElementById("tr-ap-artist");
    els.apDuration = document.getElementById("tr-ap-duration");
    els.apProgress = document.getElementById("tr-ap-progress");
    els.apBuffered = document.getElementById("tr-ap-buffered");
    els.apFill = document.getElementById("tr-ap-fill");
    els.apHoverTime = document.getElementById("tr-ap-hover-time");
    els.apPlay = document.getElementById("tr-ap-play");
    els.apPrev = document.getElementById("tr-ap-prev");
    els.apNext = document.getElementById("tr-ap-next");
  }

  function bindEvents() {
    if (els.connectReady) {
      els.connectReady.addEventListener("click", enterRetailExperience);
    }

    if (els.apPlay) {
      els.apPlay.addEventListener("click", togglePlayback);
    }
    if (els.apPrev) {
      els.apPrev.addEventListener("click", playPrevTrack);
    }
    if (els.apNext) {
      els.apNext.addEventListener("click", playNextTrack);
    }
    if (els.apProgress) {
      els.apProgress.addEventListener("click", function (event) {
        seekInlineTrack(event, els.apProgress);
      });
      els.apProgress.addEventListener("touchstart", function (event) {
        seekInlineTrack(event, els.apProgress);
      });
      els.apProgress.addEventListener("mouseenter", showProgressHoverTime);
      els.apProgress.addEventListener("mousemove", showProgressHoverTime);
      els.apProgress.addEventListener("mouseleave", hideProgressHoverTime);
      els.apProgress.addEventListener("focus", showProgressHoverTime);
      els.apProgress.addEventListener("blur", hideProgressHoverTime);
    }

    if (els.activePlayer) {
      els.activePlayer.addEventListener("mouseenter", function () {
        state.showElapsedTime = true;
        updateActivePlayerTimeLabel();
      });
      els.activePlayer.addEventListener("mouseleave", function () {
        state.showElapsedTime = false;
        updateActivePlayerTimeLabel();
      });
      els.activePlayer.addEventListener("focusin", function () {
        state.showElapsedTime = true;
        updateActivePlayerTimeLabel();
      });
      els.activePlayer.addEventListener("focusout", function (event) {
        if (
          event.relatedTarget &&
          els.activePlayer.contains(event.relatedTarget)
        ) {
          return;
        }
        state.showElapsedTime = false;
        updateActivePlayerTimeLabel();
      });
    }

    if (els.audio) {
      els.audio.addEventListener("loadstart", onAudioLoadStart);
      els.audio.addEventListener("loadedmetadata", onAudioLoadedMetadata);
      els.audio.addEventListener("progress", onAudioProgress);
      els.audio.addEventListener("timeupdate", onAudioTimeUpdate);
      els.audio.addEventListener("play", onAudioPlay);
      els.audio.addEventListener("pause", onAudioPause);
      els.audio.addEventListener("canplay", onAudioCanPlay);
      els.audio.addEventListener("canplaythrough", onAudioCanPlay);
      els.audio.addEventListener("playing", onAudioPlaying);
      els.audio.addEventListener("waiting", onAudioWaiting);
      els.audio.addEventListener("stalled", onAudioWaiting);
      els.audio.addEventListener("seeking", onAudioSeeking);
      els.audio.addEventListener("seeked", onAudioSeeked);
      els.audio.addEventListener("ended", onAudioEnded);
      els.audio.addEventListener("error", onAudioError);
    }

    window.addEventListener("resize", function () {
      if (sceneAnimation && typeof sceneAnimation.resize === "function") {
        sceneAnimation.resize();
      }

      positionConnectHotspot();
    });

    if (els.splashVideo) {
      els.splashVideo.addEventListener(
        "loadedmetadata",
        positionConnectHotspot,
      );
      els.splashVideo.addEventListener("loadeddata", positionConnectHotspot);
    }
  }

  function initSplash() {
    if (!els.intro) {
      return;
    }

    document.body.classList.add("tr-body--splash-active");

    if (!els.splashVideo) {
      window.setTimeout(showConnectScreen, 3000);
      return;
    }

    els.splashVideo.muted = true;
    els.splashVideo.defaultMuted = true;
    els.splashVideo.playsInline = true;
    els.splashVideo.playbackRate = SPLASH_PLAYBACK_RATE;

    if (!els.splashVideo.querySelector("source") && !els.splashVideo.src) {
      els.splashVideo.src = SPLASH_VIDEO_PATH;
    }

    els.splashVideo.addEventListener("timeupdate", onSplashTimeUpdate);
    els.splashVideo.addEventListener(
      "error",
      function () {
        showConnectScreen();
      },
      { once: true },
    );

    try {
      els.splashVideo.load();
    } catch (error) {}

    window.setTimeout(startPhase2, SPLASH_STATIC_MS);
    window.setTimeout(function () {
      if (!state.splashDismissed) {
        showConnectScreen();
      }
    }, SPLASH_FALLBACK_END_MS);
  }

  function startPhase2() {
    if (state.splashDismissed) {
      return;
    }

    if (window.gsap && els.splashFeel) {
      window.gsap.fromTo(
        els.splashFeel,
        { backgroundPosition: "0% 50%" },
        {
          backgroundPosition: "100% 50%",
          duration: SPLASH_GRADIENT_DURATION,
          ease: "linear",
        },
      );
    }

    if (els.splashVideo) {
      els.splashVideo.playbackRate = SPLASH_PLAYBACK_RATE;
      var playPromise = els.splashVideo.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    }
  }

  function onSplashTimeUpdate() {
    if (!els.splashVideo) {
      return;
    }

    var currentTime = els.splashVideo.currentTime;

    if (!state.splashFadeStarted && currentTime >= SPLASH_TEXT_FADE_AT) {
      state.splashFadeStarted = true;
      if (els.splashText) {
        els.splashText.style.transition =
          "opacity " + SPLASH_TEXT_FADE_DURATION + "s ease";
        els.splashText.style.opacity = 0;
      }
    }

    if (currentTime >= SPLASH_CLIP_END) {
      try {
        els.splashVideo.pause();
        els.splashVideo.currentTime = SPLASH_CLIP_END;
      } catch (error) {}

      els.splashVideo.removeEventListener("timeupdate", onSplashTimeUpdate);

      window.setTimeout(function () {
        showConnectScreen();
      }, SPLASH_CONNECT_TRANSITION_DELAY);
    }
  }

  function showConnectScreen() {
    if (state.splashDismissed) {
      return;
    }

    state.splashDismissed = true;

    if (els.splashText) {
      els.splashText.hidden = true;
    }

    if (els.connectText) {
      els.connectText.hidden = false;
      els.connectText.style.opacity = 0;
      window.setTimeout(function () {
        els.connectText.style.opacity = 1;
      }, 50);
    }

    if (els.introFooter) {
      els.introFooter.classList.add("is-visible");
    }

    if (els.intro) {
      els.intro.classList.add("tr-intro--hide-logo");
    }

    startConnectLoop();
    window.requestAnimationFrame(positionConnectHotspot);

    window.dispatchEvent(new CustomEvent("retail:screen_view", {
      detail: { screen_name: "connect", previous_screen_name: "splash" }
    }));
  }

  function enterRetailExperience() {
    if (state.introDismissed || state.introTransitionStarted) {
      return;
    }
    state.introTransitionStarted = true;

    window.dispatchEvent(new CustomEvent("retail:connect_cta_click", {
      detail: { cta_id: "connect_continue" }
    }));

    if (els.intro) {
      els.intro.classList.add("is-transitioning");
    }

    if (els.splashVideo) {
      try {
        stopConnectLoop();
        els.splashVideo.currentTime = SPLASH_RESUME_START;
        var playPromise = els.splashVideo.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }

        if (els.connectText) {
          els.connectText.style.opacity = 0;
        }
        if (els.introFooter) {
          els.introFooter.classList.remove("is-visible");
        }

        els.splashVideo.addEventListener("ended", dismissIntroFrame, {
          once: true,
        });
        window.setTimeout(dismissIntroFrame, 5000);
      } catch (e) {
        dismissIntroFrame();
      }
    } else {
      dismissIntroFrame();
    }
  }

  function dismissIntroFrame() {
    if (state.introDismissed) {
      return;
    }
    state.introDismissed = true;

    if (els.intro) {
      els.intro.classList.remove("is-transitioning");
    }

    if (els.splashVideo) {
      try {
        els.splashVideo.pause();
      } catch (e) {}
      stopConnectLoop();
      els.splashVideo.removeEventListener("ended", dismissIntroFrame);
    }

    if (els.intro) {
      els.intro.classList.add("is-dismissed");
      window.setTimeout(function () {
        if (els.intro) {
          els.intro.hidden = true;
        }
      }, 560);
    }

    if (els.root) {
      els.root.classList.remove("is-splash-active");
      els.root.classList.remove("is-flow-hidden");
    }

    document.body.classList.remove("tr-body--splash-active");
    animateHeroEntrance();
    window.scrollTo({ top: 0, behavior: "smooth" });

    window.dispatchEvent(new CustomEvent("retail:screen_view", {
      detail: { screen_name: "player", previous_screen_name: "connect" }
    }));
  }

  function animateHeroEntrance() {
    if (
      state.heroIntroPlayed ||
      !window.gsap ||
      (!els.modeHeading && !els.heroSubtitle)
    ) {
      return;
    }

    state.heroIntroPlayed = true;

    if (els.modeHeadingGradient) {
      window.gsap.set(els.modeHeadingGradient, {
        clipPath: "inset(0 100% 0 0)",
        backgroundPosition: "0% 50%",
      });
    }

    state.heroIntroTimeline = window.gsap.timeline();

    if (els.modeHeading) {
      state.heroIntroTimeline.fromTo(
        els.modeHeading,
        {
          opacity: 0,
          y: 18,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.42,
          ease: "power2.out",
          clearProps: "transform",
        },
      );
    }

    if (els.modeHeadingGradient) {
      state.heroIntroTimeline.to(
        els.modeHeadingGradient,
        {
          clipPath: "inset(0 0% 0 0)",
          backgroundPosition: "100% 50%",
          duration: 0.7,
          ease: "power3.out",
          clearProps: "clipPath",
        },
        0.08,
      );
    }

    if (els.heroSubtitle) {
      state.heroIntroTimeline.fromTo(
        els.heroSubtitle,
        {
          opacity: 0,
          y: 14,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.38,
          ease: "power2.out",
          clearProps: "transform",
        },
        0.18,
      );
    }
  }

  function startConnectLoop() {
    if (!els.splashVideo) {
      return;
    }

    stopConnectLoop();

    try {
      els.splashVideo.currentTime = CONNECT_LOOP_START;
      var playPromise = els.splashVideo.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    } catch (error) {}

    els.splashVideo.addEventListener("timeupdate", onConnectLoopTimeUpdate);
  }

  function stopConnectLoop() {
    if (!els.splashVideo) {
      return;
    }

    els.splashVideo.removeEventListener("timeupdate", onConnectLoopTimeUpdate);
  }

  function onConnectLoopTimeUpdate() {
    if (!els.splashVideo || state.introTransitionStarted) {
      return;
    }

    if (els.splashVideo.currentTime >= CONNECT_LOOP_END) {
      try {
        els.splashVideo.currentTime = CONNECT_LOOP_START;
      } catch (error) {}
    }
  }

  function positionConnectHotspot() {
    var mediaRect;
    var videoWidth;
    var videoHeight;
    var mediaWidth;
    var mediaHeight;
    var scale;
    var renderedWidth;
    var renderedHeight;
    var offsetLeft;
    var offsetTop;
    var x;
    var y;

    if (!els.connectHotspot || !els.introMedia || !els.splashVideo) {
      return;
    }

    mediaRect = els.introMedia.getBoundingClientRect();
    mediaWidth = mediaRect.width || 0;
    mediaHeight = mediaRect.height || 0;
    videoWidth = els.splashVideo.videoWidth || 0;
    videoHeight = els.splashVideo.videoHeight || 0;

    if (!mediaWidth || !mediaHeight || !videoWidth || !videoHeight) {
      return;
    }

    scale = Math.min(mediaWidth / videoWidth, mediaHeight / videoHeight);
    renderedWidth = videoWidth * scale;
    renderedHeight = videoHeight * scale;
    offsetLeft = (mediaWidth - renderedWidth) / 2;
    offsetTop = (mediaHeight - renderedHeight) / 2;
    x = offsetLeft + renderedWidth * CONNECT_HOTSPOT_X;
    y = offsetTop + renderedHeight * CONNECT_HOTSPOT_Y;

    els.connectHotspot.style.left = x + "px";
    els.connectHotspot.style.top = y + "px";
  }

  function loadData() {
    return fetch(DATA_PATH, { cache: "no-store" })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Unable to load temp_retail-data.json");
        }
        return response.json();
      })
      .catch(function () {
        return DEFAULT_INLINE_DATA;
      });
  }

  function normalizeModes(modes) {
    return (modes || []).map(function (mode) {
      return normalizeMode(mode);
    });
  }

  function normalizeMode(mode) {
    var safeMode = mode || {};
    return {
      id: safeMode.id || "",
      title: safeMode.title || safeMode.id || "",
      displayTitle: (safeMode.title || safeMode.id || "").toUpperCase(),
      tabSub: safeMode.tab_sub || MODE_TAB_COPY[safeMode.id] || "",
      state_frame:
        typeof safeMode.state_frame === "number" ? safeMode.state_frame : 0,
      description:
        safeMode.description ||
        safeMode.short_description ||
        extractText(safeMode.description_html),
      playlist: sortTracks(safeMode.playlist || []),
    };
  }

  function initScene() {
    return new Promise(function (resolve) {
      if (!window.lottie || !els.visualScene) {
        resolve();
        return;
      }

      sceneAnimation = window.lottie.loadAnimation({
        container: els.visualScene,
        renderer: "canvas",
        loop: false,
        autoplay: false,
        path: MODE_ANIMATION_PATH,
        rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
      });

      sceneAnimation.addEventListener("DOMLoaded", function () {
        state.sceneReady = true;
        renderSceneFrame();
        resolve();
      });

      sceneAnimation.addEventListener("data_failed", function () {
        if (els.visualContainer) {
          els.visualContainer.classList.add("is-fallback");
        }
        resolve();
      });
    });
  }

  function renderSceneFrame() {
    if (!sceneAnimation) {
      return;
    }

    sceneAnimation.goToAndStop(Math.round(state.frameProxy.frame || 0), true);
  }

  function renderTabs() {
    if (!els.tabs) {
      return;
    }

    els.tabs.innerHTML = "";

    state.modes.forEach(function (mode) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "tr-mode-tab";
      button.dataset.id = mode.id;
      button.setAttribute("role", "tab");
      button.setAttribute("aria-selected", "false");
      button.innerHTML =
        '<span class="tr-mode-tab__name">' +
        escapeHtml(mode.displayTitle) +
        "</span>" +
        '<span class="tr-mode-tab__sub">' +
        escapeHtml(mode.tabSub) +
        "</span>";

      button.addEventListener("click", function () {
        switchMode(mode.id, false);
      });

      els.tabs.appendChild(button);
    });
  }

  function switchMode(modeId, immediate) {
    var mode = getMode(modeId);
    if (!mode) {
      return;
    }

    if (!immediate && state.activeModeId === mode.id) {
      return;
    }

    stopPlayback();
    primeFirstTrack(mode);
    preloadModeArtwork(mode);
    syncActiveTabs(mode.id);

    if (state.currentTimeline) {
      state.currentTimeline.kill();
      state.currentTimeline = null;
    }

    if (immediate || !window.gsap) {
      state.activeModeId = mode.id;
      updateModeCopy(mode);
      state.frameProxy.frame = mode.state_frame || 0;
      renderSceneFrame();
      renderPlaylist(mode);
      window.dispatchEvent(new CustomEvent("retail:demo_mode_select", {
        detail: {
          demo_mode_id:   mode.id,
          demo_mode_name: mode.displayTitle || mode.title || mode.id
        }
      }));
      return;
    }

    state.currentTimeline = window.gsap.timeline({
      defaults: { ease: "power2.out" },
      onComplete: function () {
        state.currentTimeline = null;
        window.requestAnimationFrame(scrollPlaylistIntoView);
      },
    });

    state.currentTimeline
      .to(
        [els.modeTitle, els.modeDescription],
        {
          opacity: 0,
          y: -16,
          duration: 0.18,
        },
        0,
      )
      .to(
        els.playlistSection,
        {
          opacity: 0.76,
          x: 10,
          duration: 0.18,
        },
        0,
      )
      .to(
        els.visualStage,
        {
          scale: 0.985,
          duration: 0.12,
          ease: "power1.inOut",
          yoyo: true,
          repeat: 1,
        },
        0,
      )
      .to(
        state.frameProxy,
        {
          frame: mode.state_frame || 0,
          duration: 0.28,
          onUpdate: renderSceneFrame,
        },
        0,
      )
      .add(function () {
        state.activeModeId = mode.id;
        updateModeCopy(mode);
        renderPlaylist(mode);
        window.dispatchEvent(new CustomEvent("retail:demo_mode_select", {
          detail: {
            demo_mode_id:   mode.id,
            demo_mode_name: mode.displayTitle || mode.title || mode.id
          }
        }));
      }, 0.19)
      .fromTo(
        [els.modeTitle, els.modeDescription],
        {
          opacity: 0,
          y: 16,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.22,
          clearProps: "transform",
        },
        0.19,
      )
      .fromTo(
        els.playlistSection,
        {
          opacity: 0.76,
          x: -10,
        },
        {
          opacity: 1,
          x: 0,
          duration: 0.22,
          clearProps: "transform",
        },
        0.19,
      );
  }

  function syncActiveTabs(modeId) {
    if (!els.tabs) {
      return;
    }

    Array.prototype.forEach.call(
      els.tabs.querySelectorAll(".tr-mode-tab"),
      function (tab) {
        var active = tab.dataset.id === modeId;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      },
    );
  }

  function updateModeCopy(mode) {
    if (els.modeTitle) {
      els.modeTitle.textContent = mode.displayTitle;
    }

    if (els.modeDescription) {
      els.modeDescription.textContent = mode.description || "";
    }

    if (els.disclaimerMode) {
      els.disclaimerMode.textContent = mode.displayTitle;
    }

    if (els.playlistMode) {
      els.playlistMode.textContent = mode.displayTitle;
    }

    updateExitCopy(mode);
  }

  function updateExitCopy(mode) {
    var isBeast = !!(mode && mode.id === "beast");

    if (els.exitTitle) {
      els.exitTitle.textContent = isBeast
        ? "Felt the difference?"
        : "Experience other modes";
    }

    if (els.exitDescription) {
      els.exitDescription.innerHTML = isBeast
        ? "Now play what you love. <br>Find your sweet spot with every mode."
        : "Try all 4 to feel the difference.";
    }
  }

  function renderPlaylist(mode) {
    if (!els.playlistList) {
      return;
    }

    var tracks = sortTracks(mode.playlist || []);
    state.playableTracks = tracks.filter(isPlayableTrack);

    if (
      state.currentTrackId &&
      !tracks.some(function (track) {
        return track.id === state.currentTrackId;
      })
    ) {
      state.currentTrackId = null;
      state.isPlaying = false;
      state.isBuffering = false;
      state.audioStatus = "idle";
      state.audioMessage = "";
    }

    els.playlistList.innerHTML = "";

    tracks.forEach(function (track) {
      var item = document.createElement("div");
      var isActive = state.currentTrackId === track.id;
      var thumbIcon = isActive
        ? '<span class="tr-track-state-icon">' + trackControlIcon() + "</span>"
        : "";
      var thumbMarkup = buildTrackThumbMarkup(track, thumbIcon);

      item.className =
        "tr-track-item" +
        (isActive ? " is-playing" : "") +
        (isPlayableTrack(track) ? "" : " is-disabled");
      item.dataset.trackId = track.id;

      item.innerHTML =
        '<div class="tr-track-main">' +
        '<div class="tr-track-meta">' +
        thumbMarkup +
        '<div class="tr-track-text">' +
        "<strong>" +
        escapeHtml(track.title || "Song name") +
        "</strong>" +
        "<span>" +
        escapeHtml(track.artist || "Artist name") +
        "</span>" +
        "</div>" +
        "</div>" +
        '<div class="tr-track-duration">' +
        escapeHtml(track.duration || "") +
        "</div>" +
        "</div>";

      if (isPlayableTrack(track)) {
        item.addEventListener("click", function () {
          handleTrackSelection(track.id);
        });
      }

      els.playlistList.appendChild(item);
    });

    updateActivePlayerIcon();
  }

  function handleTrackSelection(trackId) {
    var currentMode = getCurrentMode();
    if (!currentMode) {
      return;
    }

    if (trackId === state.currentTrackId) {
      if (state.isBuffering) {
        return;
      }
      togglePlayback();
      return;
    }

    var track = getTrackById(currentMode, trackId);
    if (!track || !isPlayableTrack(track) || !els.audio) {
      return;
    }

    // Skip detection: different track selected while current was playing < 25%
    if (state.currentTrackId && (state.isPlaying || state.isBuffering) && els.audio) {
      var dur = els.audio.duration || 0;
      var pos = els.audio.currentTime || 0;
      var pct = dur > 0 ? Math.round((pos / dur) * 100) : 0;
      if (pct < 25 && dur > 0) {
        window.dispatchEvent(new CustomEvent("retail:track_skip", {
          detail: {
            track_id:           state.currentTrackId,
            demo_mode_id:       state.activeModeId || "",
            skipped_at_percent: pct,
            skip_reason:        "track_change"
          }
        }));
      }
    }

    var isPrimed = state.primedTrackId === trackId;
    state.primedTrackId = null;

    resetSilentBuffering();
    state.currentTrackId = track.id;
    state.pendingPlaybackAfterBuffer = true;
    state.rebufferAfterStall = false;
    state.startupBufferTargetSec = TRACK_STARTUP_BUFFER_MAX_SECONDS;
    state.suppressPauseMessage = false;
    state.showElapsedTime = false;
    setPlayState(false, false);
    setBufferingState(true, buildStartupBufferMessage());
    updateProgress(0);
    updateBufferedProgress(0);
    renderPlaylist(currentMode);
    showActivePlayer(track);

    if (!isPrimed) {
      els.audio.src = track.audio_url;
      try {
        els.audio.load();
      } catch (error) {}
    }

    startSilentBuffering(track.id);
    checkBufferedPlaybackReady();
  }

  function togglePlayback() {
    var resumeGoal;

    if (!els.audio) {
      return;
    }

    if (!state.currentTrackId) {
      if (state.playableTracks.length) {
        handleTrackSelection(state.playableTracks[0].id);
      }
      return;
    }

    if (state.pendingPlaybackAfterBuffer) {
      setBufferingState(true, buildStartupBufferMessage());
      checkBufferedPlaybackReady();
      return;
    }

    if (state.isPlaying) {
      els.audio.pause();
      return;
    }

    resumeGoal = getResumeBufferGoalSeconds();
    if (getBufferedAheadSeconds(els.audio.currentTime || 0) < resumeGoal) {
      state.pendingPlaybackAfterBuffer = false;
      state.rebufferAfterStall = true;
      setBufferingState(true, buildRebufferMessage());
      checkBufferedPlaybackReady();
      return;
    }

    attemptAudioPlay();
  }

  function playPrevTrack() {
    if (!state.playableTracks.length) {
      return;
    }

    if (!state.currentTrackId) {
      handleTrackSelection(state.playableTracks[0].id);
      return;
    }

    var currentIndex = indexOfTrack(state.currentTrackId);
    var nextIndex =
      currentIndex <= 0 ? state.playableTracks.length - 1 : currentIndex - 1;
    handleTrackSelection(state.playableTracks[nextIndex].id);
  }

  function playNextTrack() {
    if (!state.playableTracks.length) {
      return;
    }

    if (!state.currentTrackId) {
      handleTrackSelection(state.playableTracks[0].id);
      return;
    }

    var currentIndex = indexOfTrack(state.currentTrackId);
    var nextIndex =
      currentIndex >= state.playableTracks.length - 1 ? 0 : currentIndex + 1;
    handleTrackSelection(state.playableTracks[nextIndex].id);
  }

  function stopPlayback() {
    if (!els.audio) {
      return;
    }

    try {
      if (!els.audio.paused) {
        els.audio.pause();
      }
    } catch (error) {}

    els.audio.removeAttribute("src");

    try {
      els.audio.load();
    } catch (error) {}

    state.currentTrackId = null;
    state.playableTracks = [];
    state.isPlaying = false;
    state.isBuffering = false;
    state.audioStatus = "idle";
    state.audioMessage = "";
    state.primedTrackId = null;
    state.pendingPlaybackAfterBuffer = false;
    state.rebufferAfterStall = false;
    state.startupBufferTargetSec = 0;
    state.suppressPauseMessage = false;
    resetSilentBuffering();
    state.showElapsedTime = false;
    hideProgressHoverTime();
    updateProgress(0);
    updateBufferedProgress(0);
    hideActivePlayer();
  }

  function primeAudio(track) {
    if (!els.audio || !track || !isPlayableTrack(track)) {
      return;
    }
    if (state.primedTrackId === track.id) {
      return;
    }
    els.audio.preload = "auto";
    els.audio.src = track.audio_url;
    try {
      els.audio.load();
    } catch (e) {}
    state.primedTrackId = track.id;
  }

  function primeFirstTrack(mode) {
    var tracks = sortTracks((mode && mode.playlist) || []).filter(
      isPlayableTrack,
    );
    if (tracks.length) {
      primeAudio(tracks[0]);
    }
  }

  function preloadModeArtwork(mode) {
    sortTracks((mode && mode.playlist) || []).forEach(function (track) {
      preloadArtwork(track && track.cover_image);
    });
  }

  function preloadAllArtwork(modes) {
    (modes || []).forEach(function (mode) {
      preloadModeArtwork(mode);
    });
  }

  function preloadArtwork(url) {
    var image;

    if (
      !url ||
      url.indexOf("PLACEHOLDER") !== -1 ||
      state.preloadedImageUrls[url]
    ) {
      return;
    }

    image = new Image();
    image.decoding = "async";
    image.loading = "eager";
    image.src = url;
    state.preloadedImageUrls[url] = image;
  }

  function preloadTrack(url) {
    if (!els.audioPreload || !url || url.indexOf("PLACEHOLDER") !== -1) {
      return;
    }
    if (els.audioPreload.src === url) {
      return;
    }
    els.audioPreload.src = url;
    els.audioPreload.load();
  }

  function preloadNextTrack() {
    if (!state.currentTrackId || !state.playableTracks.length) {
      return;
    }
    var currentIndex = indexOfTrack(state.currentTrackId);
    var nextIndex =
      currentIndex >= state.playableTracks.length - 1 ? 0 : currentIndex + 1;
    var next = state.playableTracks[nextIndex];
    if (next && next.id !== state.currentTrackId) {
      preloadTrack(next.audio_url);
    }
  }

  function startSilentBuffering(trackId) {
    var playPromise;

    if (!els.audio || !state.pendingPlaybackAfterBuffer) {
      return;
    }

    state.silentBuffering = true;
    state.restoreMutedAfterBuffer = !els.audio.muted;
    state.suppressPauseMessage = true;
    els.audio.muted = true;

    playPromise = els.audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {
        if (
          trackId !== state.currentTrackId ||
          !state.pendingPlaybackAfterBuffer
        ) {
          return;
        }
        state.silentBuffering = false;
        if (state.restoreMutedAfterBuffer) {
          els.audio.muted = false;
        }
        state.restoreMutedAfterBuffer = false;
        setBufferingState(true, buildStartupBufferMessage());
      });
    }
  }

  function resetSilentBuffering() {
    if (els.audio && state.restoreMutedAfterBuffer) {
      els.audio.muted = false;
    }

    state.silentBuffering = false;
    state.restoreMutedAfterBuffer = false;
    state.suppressSeekBuffering = false;
  }

  function startBufferedPlayback() {
    finishSilentBuffering();
    state.suppressPauseMessage = false;
    setBufferingState(false, "Playing now.");
    setPlayState(true, true);

    if (els.audio && els.audio.paused) {
      attemptAudioPlay();
      return;
    }

    preloadNextTrack();
  }

  function finishSilentBuffering() {
    if (!els.audio) {
      return;
    }

    if (state.silentBuffering && els.audio.currentTime > 0.05) {
      state.suppressSeekBuffering = true;
      try {
        els.audio.currentTime = 0;
      } catch (error) {}
      window.setTimeout(function () {
        state.suppressSeekBuffering = false;
      }, 300);
    }

    if (state.restoreMutedAfterBuffer) {
      els.audio.muted = false;
    }

    state.silentBuffering = false;
    state.restoreMutedAfterBuffer = false;
  }

  function onAudioLoadStart() {
    if (!state.currentTrackId) {
      return;
    }

    if (state.pendingPlaybackAfterBuffer) {
      setBufferingState(true, buildStartupBufferMessage());
      return;
    }

    if (state.rebufferAfterStall) {
      setBufferingState(true, buildRebufferMessage());
      return;
    }

    setBufferingState(true, "Connecting audio...");
  }

  function onAudioLoadedMetadata() {
    state.startupBufferTargetSec = getStartupBufferGoalSeconds();
    if (state.pendingPlaybackAfterBuffer) {
      setBufferingState(true, buildStartupBufferMessage());
    }
    updateProgress(getProgressPercent());
    updateBufferedProgress(getBufferedPercentAtTime(0));
    updateActivePlayerTimeLabel();
    checkBufferedPlaybackReady();
  }

  function onAudioProgress() {
    updateBufferedProgress(getBufferedPercentAtCurrentTime());
    checkBufferedPlaybackReady();
  }

  function onAudioTimeUpdate() {
    updateProgress(getProgressPercent());
    updateBufferedProgress(getBufferedPercentAtCurrentTime());
    updateActivePlayerTimeLabel();
  }

  function onAudioPlay() {
    if (state.silentBuffering && state.pendingPlaybackAfterBuffer) {
      setPlayState(false, false);
      setBufferingState(true, buildStartupBufferMessage());
      return;
    }

    setPlayState(true, false);
    preloadNextTrack();
  }

  function onAudioPause() {
    setPlayState(false, false);

    if (state.silentBuffering && state.pendingPlaybackAfterBuffer) {
      return;
    }

    if (state.suppressPauseMessage) {
      state.suppressPauseMessage = false;
      return;
    }

    if (
      state.currentTrackId &&
      !state.isBuffering &&
      state.audioStatus !== "error"
    ) {
      setAudioStatus("paused", "Playback paused.", true);
      var _posS = els.audio ? Math.round(els.audio.currentTime || 0) : 0;
      var _dur  = els.audio ? (els.audio.duration || 0) : 0;
      var _posP = _dur > 0 ? Math.round((_posS / _dur) * 100) : 0;
      window.dispatchEvent(new CustomEvent("retail:track_pause", {
        detail: {
          track_id:         state.currentTrackId,
          demo_mode_id:     state.activeModeId || "",
          position_seconds: _posS,
          position_percent: _posP
        }
      }));
    }
  }

  function onAudioCanPlay() {
    if (!state.currentTrackId) {
      return;
    }

    if (state.pendingPlaybackAfterBuffer || state.rebufferAfterStall) {
      checkBufferedPlaybackReady();
      return;
    }

    if (state.isPlaying) {
      return;
    }

    setBufferingState(false, "Tap play to start.");
  }

  function onAudioPlaying() {
    if (state.silentBuffering && state.pendingPlaybackAfterBuffer) {
      setPlayState(false, false);
      setBufferingState(true, buildStartupBufferMessage());
      return;
    }

    state.pendingPlaybackAfterBuffer = false;
    state.rebufferAfterStall = false;
    setBufferingState(false, "Playing now.");
    setPlayState(true, true);

    if (state.currentTrackId) {
      var _mode  = getCurrentMode();
      var _track = _mode ? getTrackById(_mode, state.currentTrackId) : null;
      window.dispatchEvent(new CustomEvent("retail:track_play", {
        detail: {
          track_id:       state.currentTrackId,
          track_title:    (_track && _track.title)        || "",
          demo_mode_id:   state.activeModeId              || "",
          demo_mode_name: (_mode  && _mode.displayTitle)  || ""
        }
      }));
    }
  }

  function onAudioWaiting() {
    if (!state.currentTrackId) {
      return;
    }

    if (state.suppressSeekBuffering) {
      return;
    }

    if (state.silentBuffering && state.pendingPlaybackAfterBuffer) {
      setBufferingState(true, buildStartupBufferMessage());
      checkBufferedPlaybackReady();
      return;
    }

    state.pendingPlaybackAfterBuffer = false;
    state.rebufferAfterStall = true;
    state.suppressPauseMessage = true;

    try {
      if (!els.audio.paused) {
        els.audio.pause();
      }
    } catch (error) {}

    setBufferingState(true, buildRebufferMessage());
    checkBufferedPlaybackReady();
  }

  function onAudioSeeking() {
    if (!state.currentTrackId) {
      return;
    }

    if (state.suppressSeekBuffering) {
      return;
    }

    state.pendingPlaybackAfterBuffer = false;
    state.rebufferAfterStall = true;
    setBufferingState(true, "Seeking track...");
  }

  function onAudioSeeked() {
    if (!state.currentTrackId) {
      return;
    }

    if (state.suppressSeekBuffering) {
      state.suppressSeekBuffering = false;
      updateProgress(getProgressPercent());
      return;
    }

    if (state.rebufferAfterStall) {
      checkBufferedPlaybackReady();
      return;
    }

    setBufferingState(
      false,
      state.isPlaying ? "Playing now." : "Ready to play.",
    );
  }

  function onAudioEnded() {
    state.pendingPlaybackAfterBuffer = false;
    state.rebufferAfterStall = false;
    setBufferingState(false, "");
    setPlayState(false, false);
    updateBufferedProgress(100);
    updateActivePlayerTimeLabel();

    if (state.currentTrackId) {
      window.dispatchEvent(new CustomEvent("retail:track_complete", {
        detail: {
          track_id:               state.currentTrackId,
          demo_mode_id:           state.activeModeId || "",
          track_duration_seconds: els.audio ? Math.round(els.audio.duration || 0) : 0
        }
      }));
    }

    playNextTrack();
  }

  function onAudioError() {
    state.pendingPlaybackAfterBuffer = false;
    state.rebufferAfterStall = false;
    resetSilentBuffering();
    setBufferingState(false, "This track could not be loaded.");
    setPlayState(false, false);
    setAudioStatus("error", "This track could not be loaded.", true);

    window.dispatchEvent(new CustomEvent("retail:error", {
      detail: {
        error_type:          "audio_error",
        error_message_short: "audio failed to load",
        demo_mode_id:        state.activeModeId  || "",
        track_id:            state.currentTrackId || ""
      }
    }));
  }

  function setPlayState(isPlaying, rerender) {
    state.isPlaying = !!isPlaying;
    updateActivePlayerIcon();
    if (rerender) {
      rerenderPlaylist();
    }
  }

  function setBufferingState(isBuffering, message) {
    state.isBuffering = !!isBuffering;
    if (state.isBuffering) {
      state.audioStatus = "buffering";
      state.audioMessage = message || "Loading audio...";
    } else if (state.audioStatus === "buffering") {
      state.audioStatus = message ? "ready" : "idle";
      state.audioMessage = message || "";
    } else if (message) {
      state.audioMessage = message;
    }

    rerenderPlaylist();
  }

  function setAudioStatus(status, message, rerender) {
    state.audioStatus = status;
    state.audioMessage = message || "";
    if (rerender) {
      rerenderPlaylist();
    }
  }

  function rerenderPlaylist() {
    var currentMode = getCurrentMode();
    if (currentMode) {
      renderPlaylist(currentMode);
    }
  }

  function checkBufferedPlaybackReady() {
    var bufferedAhead;

    if (!els.audio || !state.currentTrackId) {
      return;
    }

    if (state.pendingPlaybackAfterBuffer) {
      state.startupBufferTargetSec = getStartupBufferGoalSeconds();
      bufferedAhead = getBufferedAheadSeconds(0);
      if (
        bufferedAhead >= state.startupBufferTargetSec ||
        (bufferedAhead >= TRACK_STARTUP_READY_STATE_SECONDS &&
          els.audio.readyState >= 3) ||
        hasBufferedToTrackEnd(0)
      ) {
        state.pendingPlaybackAfterBuffer = false;
        startBufferedPlayback();
      }
      return;
    }

    if (state.rebufferAfterStall) {
      bufferedAhead = getBufferedAheadSeconds(els.audio.currentTime || 0);
      if (
        bufferedAhead >= getResumeBufferGoalSeconds() ||
        hasBufferedToTrackEnd(els.audio.currentTime || 0)
      ) {
        state.rebufferAfterStall = false;
        attemptAudioPlay();
      }
    }
  }

  function attemptAudioPlay() {
    var playPromise;

    if (!els.audio) {
      return;
    }

    playPromise = els.audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {
        setBufferingState(false, "Tap play to start.");
        setPlayState(false, false);
      });
    }
  }

  function getStartupBufferGoalSeconds() {
    var duration = els.audio ? els.audio.duration : 0;
    var goal;

    if (!duration || !isFinite(duration)) {
      return TRACK_STARTUP_BUFFER_MIN_SECONDS;
    }

    goal = Math.max(
      TRACK_STARTUP_BUFFER_MIN_SECONDS,
      duration * TRACK_STARTUP_BUFFER_RATIO,
    );
    goal = Math.min(TRACK_STARTUP_BUFFER_MAX_SECONDS, goal);
    goal = Math.min(
      goal,
      Math.max(TRACK_STARTUP_READY_STATE_SECONDS, duration - 0.25),
    );

    return goal;
  }

  function getResumeBufferGoalSeconds() {
    var duration = els.audio ? els.audio.duration : 0;
    var currentTime = els.audio ? els.audio.currentTime || 0 : 0;
    var remaining =
      duration && isFinite(duration) ? Math.max(0, duration - currentTime) : 0;
    var goal = TRACK_REBUFFER_SECONDS;

    if (remaining) {
      goal = Math.min(goal, Math.max(3, remaining * TRACK_REBUFFER_RATIO));
    }

    return goal;
  }

  function getBufferedAheadSeconds(fromTime) {
    var buffered;
    var i;
    var start;
    var end;
    var safeTime = Math.max(0, Number(fromTime) || 0);

    if (!els.audio || !els.audio.buffered || !els.audio.buffered.length) {
      return 0;
    }

    buffered = els.audio.buffered;
    for (i = 0; i < buffered.length; i += 1) {
      start = buffered.start(i);
      end = buffered.end(i);
      if (safeTime === 0 && start <= 1) {
        return Math.max(0, end);
      }
      if (safeTime >= start - 0.2 && safeTime <= end + 0.05) {
        return Math.max(0, end - safeTime);
      }
    }

    return 0;
  }

  function hasBufferedToTrackEnd(fromTime) {
    var duration = els.audio ? els.audio.duration : 0;
    var bufferedAhead = getBufferedAheadSeconds(fromTime);
    var remaining;

    if (!duration || !isFinite(duration)) {
      return false;
    }

    remaining = Math.max(0, duration - Math.max(0, Number(fromTime) || 0));
    return bufferedAhead >= Math.max(0, remaining - 0.4);
  }

  function buildStartupBufferMessage() {
    return (
      "Loading " +
      Math.round(
        state.startupBufferTargetSec || TRACK_STARTUP_BUFFER_MIN_SECONDS,
      ) +
      "s of audio..."
    );
  }

  function buildRebufferMessage() {
    return (
      "Stabilizing " +
      Math.round(getResumeBufferGoalSeconds()) +
      "s of audio..."
    );
  }

  function updateProgress(percent) {
    var safePercent = Math.max(0, Math.min(100, percent || 0));
    var visualPercent = safePercent > 0 ? Math.max(safePercent, 1.5) : 0;

    state.playedPercent = safePercent;

    if (els.apFill) {
      els.apFill.style.width = visualPercent + "%";
    }
    if (els.apProgress) {
      els.apProgress.style.setProperty("--tr-ap-played", visualPercent + "%");
      els.apProgress.style.setProperty(
        "--tr-ap-buffered",
        Math.max(state.bufferedPercent, safePercent) + "%",
      );
      els.apProgress.setAttribute("aria-valuenow", Math.round(safePercent));
    }
  }

  function updateBufferedProgress(percent) {
    var safePercent = Math.max(0, Math.min(100, percent || 0));
    var visualPercent = Math.max(safePercent, state.playedPercent);

    state.bufferedPercent = safePercent;

    if (els.apBuffered) {
      els.apBuffered.style.width = visualPercent + "%";
    }
    if (els.apProgress) {
      els.apProgress.style.setProperty("--tr-ap-buffered", visualPercent + "%");
    }
  }

  function seekInlineTrack(event, progressBar) {
    var clientX;
    var rect;
    var ratio;

    if (state.pendingPlaybackAfterBuffer) {
      return;
    }

    if (
      !els.audio ||
      !progressBar ||
      !els.audio.duration ||
      !isFinite(els.audio.duration)
    ) {
      return;
    }

    clientX = getPointerClientX(event);
    if (clientX === null) {
      return;
    }

    rect = progressBar.getBoundingClientRect();
    if (!rect.width) {
      return;
    }

    ratio = clampValue((clientX - rect.left) / rect.width, 0, 1);
    els.audio.currentTime = els.audio.duration * ratio;
    updateProgress(ratio * 100);
  }

  function getPointerClientX(event) {
    if (
      event &&
      event.touches &&
      event.touches.length &&
      typeof event.touches[0].clientX === "number"
    ) {
      return event.touches[0].clientX;
    }

    if (event && typeof event.clientX === "number") {
      return event.clientX;
    }

    return null;
  }

  function getProgressPercent() {
    if (!els.audio || !els.audio.duration || !isFinite(els.audio.duration)) {
      return 0;
    }

    if (state.pendingPlaybackAfterBuffer && state.silentBuffering) {
      return 0;
    }

    return (els.audio.currentTime / els.audio.duration) * 100;
  }

  function getBufferedPercentAtCurrentTime() {
    if (!els.audio || !els.audio.duration || !isFinite(els.audio.duration)) {
      return 0;
    }

    return getBufferedPercentAtTime(0);
  }

  function getBufferedPercentAtTime(fromTime) {
    var duration = els.audio ? els.audio.duration : 0;
    var bufferedEnd;

    if (!duration || !isFinite(duration)) {
      return 0;
    }

    bufferedEnd = getBufferedEndSeconds(fromTime);
    return (bufferedEnd / duration) * 100;
  }

  function getBufferedEndSeconds(fromTime) {
    var buffered;
    var i;
    var start;
    var end;
    var safeTime = Math.max(0, Number(fromTime) || 0);
    var latestEnd = 0;

    if (!els.audio || !els.audio.buffered || !els.audio.buffered.length) {
      return 0;
    }

    buffered = els.audio.buffered;
    for (i = 0; i < buffered.length; i += 1) {
      start = buffered.start(i);
      end = buffered.end(i);
      if (safeTime <= end + 0.05) {
        latestEnd = Math.max(latestEnd, end);
      }
      if (safeTime >= start - 0.2 && safeTime <= end + 0.05) {
        return Math.max(latestEnd, end);
      }
    }

    return latestEnd;
  }

  function showProgressHoverTime(event) {
    var hoverSeconds = getHoverSeconds(event);
    var duration = els.audio ? els.audio.duration : 0;
    var percent;

    if (!els.apHoverTime || !els.apProgress) {
      return;
    }

    state.showElapsedTime = true;
    updateActivePlayerTimeLabel();

    if (hoverSeconds === null) {
      hoverSeconds = els.audio ? els.audio.currentTime || 0 : 0;
    }

    percent =
      duration && isFinite(duration)
        ? (hoverSeconds / duration) * 100
        : getProgressPercent();

    els.apHoverTime.textContent = formatTime(hoverSeconds);
    els.apHoverTime.style.left = clampValue(percent, 5, 95) + "%";
    els.apHoverTime.hidden = false;
    els.apProgress.classList.add("is-hovering");
  }

  function hideProgressHoverTime() {
    if (els.apHoverTime) {
      els.apHoverTime.hidden = true;
    }
    if (els.apProgress) {
      els.apProgress.classList.remove("is-hovering");
    }
    state.showElapsedTime = isActivePlayerHoverActive();
    updateActivePlayerTimeLabel();
  }

  function isActivePlayerHoverActive() {
    if (!els.activePlayer) {
      return false;
    }

    return (
      (typeof els.activePlayer.matches === "function" &&
        els.activePlayer.matches(":hover")) ||
      els.activePlayer.contains(document.activeElement)
    );
  }

  function getHoverSeconds(event) {
    var clientX;
    var rect;
    var duration = els.audio ? els.audio.duration : 0;
    var ratio;

    if (!els.apProgress || !duration || !isFinite(duration)) {
      return null;
    }

    clientX = getPointerClientX(event);
    if (clientX === null) {
      return els.audio ? els.audio.currentTime || 0 : 0;
    }

    rect = els.apProgress.getBoundingClientRect();
    if (!rect.width) {
      return null;
    }

    ratio = clampValue((clientX - rect.left) / rect.width, 0, 1);
    return duration * ratio;
  }

  function scrollPlaylistIntoView() {
    var viewportHeight;
    var panelRect;
    var desiredTopInViewport;
    var targetTop;
    var visibleBand;
    var isAlreadyVisible;

    if (!els.playlistSection) {
      return;
    }

    viewportHeight = Math.max(window.innerHeight || 0, 1);
    panelRect = els.playlistSection.getBoundingClientRect();
    desiredTopInViewport = clampValue(
      viewportHeight * 0.44,
      viewportHeight * 0.28,
      viewportHeight * 0.62,
    );
    targetTop = panelRect.top + window.scrollY - desiredTopInViewport;
    visibleBand = Math.max(viewportHeight * 0.05, 28);
    isAlreadyVisible =
      panelRect.top >= desiredTopInViewport - visibleBand &&
      panelRect.top <= desiredTopInViewport + visibleBand * 1.5;

    if (isAlreadyVisible || targetTop <= window.scrollY + 8) {
      return;
    }

    window.scrollTo({
      top: targetTop,
      behavior: "smooth",
    });
  }

  function showActivePlayer(track) {
    if (!els.activePlayer || !track) {
      return;
    }
    updateActivePlayerArtwork(track);
    if (els.apTitle) {
      els.apTitle.textContent = track.title || "Song name";
    }
    if (els.apArtist) {
      els.apArtist.textContent = track.artist || "Artist";
    }
    if (els.apPrev) {
      els.apPrev.innerHTML = prevIcon();
    }
    if (els.apNext) {
      els.apNext.innerHTML = nextIcon();
    }
    updateActivePlayerIcon();
    updateActivePlayerTimeLabel();
    els.activePlayer.hidden = false;
  }

  function hideActivePlayer() {
    if (!els.activePlayer) {
      return;
    }
    els.activePlayer.hidden = true;
    updateActivePlayerArtwork(null);
    updateProgress(0);
    updateBufferedProgress(0);
  }

  function updateActivePlayerArtwork(track) {
    var thumb;
    var image;

    if (!els.activePlayer) {
      return;
    }

    thumb = els.activePlayer.querySelector(".tr-ap-thumb");
    if (!thumb) {
      return;
    }

    image = thumb.querySelector(".tr-ap-thumb__image");

    if (track && track.cover_image) {
      if (image) {
        image.src = track.cover_image;
        image.alt = track.title
          ? track.title + " cover art"
          : "Track cover art";
      }
      thumb.classList.add("has-image");
      return;
    }

    if (image) {
      image.removeAttribute("src");
      image.alt = "";
    }
    thumb.classList.remove("has-image");
  }

  function buildTrackThumbMarkup(track, overlayMarkup) {
    return (
      '<div class="tr-track-thumb' +
      (track && track.cover_image ? " has-image" : "") +
      '">' +
      '<img class="tr-track-thumb__image" src="' +
      escapeHtml(track && track.cover_image ? track.cover_image : "") +
      '" alt="' +
      escapeHtml(track && track.title ? track.title + " cover art" : "") +
      '">' +
      (overlayMarkup || "") +
      "</div>"
    );
  }

  function updateActivePlayerIcon() {
    if (!els.apPlay) {
      return;
    }
    els.apPlay.innerHTML = trackControlIcon();
    els.apPlay.setAttribute(
      "aria-label",
      state.isPlaying ? "Pause track" : "Play track",
    );
  }

  function updateActivePlayerTimeLabel() {
    var currentMode;
    var track;
    var currentLabel = "0:00";
    var totalLabel = "0:00";

    if (!els.apDuration) {
      return;
    }

    currentMode = getCurrentMode();
    track =
      state.currentTrackId && currentMode
        ? getTrackById(currentMode, state.currentTrackId)
        : null;

    if (track && track.duration) {
      totalLabel = track.duration;
    }

    if (els.audio) {
      currentLabel = formatTime(
        state.pendingPlaybackAfterBuffer && state.silentBuffering
          ? 0
          : els.audio.currentTime || 0,
      );
      if (els.audio.duration && isFinite(els.audio.duration)) {
        totalLabel = formatTime(els.audio.duration);
      }
    }

    els.apDuration.textContent = state.showElapsedTime
      ? currentLabel + " / " + totalLabel
      : totalLabel;
  }

  function getMode(modeId) {
    return state.modes.find(function (mode) {
      return mode.id === modeId;
    });
  }

  function clampValue(value, minValue, maxValue) {
    return Math.min(Math.max(value, minValue), maxValue);
  }

  function getCurrentMode() {
    return getMode(state.activeModeId);
  }

  function getTrackById(mode, trackId) {
    return (mode.playlist || []).find(function (track) {
      return track.id === trackId;
    });
  }

  function sortTracks(tracks) {
    return (tracks || []).slice().sort(function (a, b) {
      var aOrder = typeof a.sort_order === "number" ? a.sort_order : 9999;
      var bOrder = typeof b.sort_order === "number" ? b.sort_order : 9999;
      return aOrder - bOrder;
    });
  }

  function indexOfTrack(trackId) {
    return state.playableTracks.findIndex(function (track) {
      return track.id === trackId;
    });
  }

  function isPlayableTrack(track) {
    return !!(track && track.audio_url);
  }

  function extractText(html) {
    if (!html) {
      return "";
    }

    var temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeAttribute(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "\\'");
  }

  function formatTime(totalSeconds) {
    var safeSeconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
    var minutes = Math.floor(safeSeconds / 60);
    var seconds = safeSeconds % 60;

    return minutes + ":" + String(seconds).padStart(2, "0");
  }

  function trackControlIcon() {
    if (state.isBuffering) {
      return spinnerIcon();
    }

    return state.isPlaying ? pauseIcon() : playIcon();
  }

  function playIcon() {
    return (
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">' +
      '<path d="M8 5v14l11-7z"></path>' +
      "</svg>"
    );
  }

  function pauseIcon() {
    return (
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">' +
      '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"></path>' +
      "</svg>"
    );
  }

  function spinnerIcon() {
    return (
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="8" opacity="0.3"></circle>' +
      '<path d="M20 12a8 8 0 0 0-8-8"></path>' +
      "</svg>"
    );
  }

  function prevIcon() {
    return (
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">' +
      '<path d="M6 6h2v12H6zm3.5 6l8.5 6V6z"></path>' +
      "</svg>"
    );
  }

  function nextIcon() {
    return (
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">' +
      '<path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"></path>' +
      "</svg>"
    );
  }
})();
